<script lang="ts" setup>
import { ref, onMounted, nextTick, useTemplateRef, type ComponentPublicInstance } from 'vue';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import { $fetch } from '@/home/plugins/fetch';
import { useI18n } from 'vue-i18n';
import { useAsyncData } from '@/home/hooks/async-data';
import ProjectSection from './components/ProjectSection.vue';
import CardPrimary from './components/CardPrimary.vue';
import CardSecondary from './components/CardSecondary.vue';

const { t, locale } = useI18n();

const descriptionList = [
  {
    title: t('projects.index.title1'),
    content: 'donorSubject',
  },
  {
    title: t('projects.index.title2'),
    content: 'contributeSubject',
  },
  {
    title: t('projects.index.title4'),
    content: 'techFeatures',
  },
  {
    title: t('projects.index.title5'),
    content: 'projectSponsor',
  },
  {
    title: t('projects.index.title3'),
    content: 'projectValue',
    clip: 2,
  },
]

const serviceTabList = ref([
  {
    title: t('projects.index.serviceTabList.title1'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title1'),
        comment: t('projects.index.serviceTabList.content.comment1'),
        image: 'https://res.oafimg.cn/-/e5b792d8af013e33/service-1.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title2'),
        comment: t('projects.index.serviceTabList.content.comment2'),
        image: 'https://res.oafimg.cn/-/9c6cc0c4abe50b19/service-2.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title3'),
        comment: t('projects.index.serviceTabList.content.comment3'),
        image: 'https://res.oafimg.cn/-/0e3fe1e7590b139e/service-3.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title4'),
        comment: t('projects.index.serviceTabList.content.comment4'),
        image: 'https://res.oafimg.cn/-/875db793f193d861/service-4.png',
      },
    ],
  },
  {
    title: t('projects.index.serviceTabList.title2'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title5'),
        comment: t('projects.index.serviceTabList.content.comment5'),
        image: 'https://res.oafimg.cn/-/46ae4acd4be07fd5/service-18.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title6'),
        comment: t('projects.index.serviceTabList.content.comment6'),
        image: 'https://res.oafimg.cn/-/7f58e65e08736e20/service-19.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title7'),
        comment: t('projects.index.serviceTabList.content.comment7'),
        image: 'https://res.oafimg.cn/-/b56d0cae264816fb/service-20.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title8'),
        comment: t('projects.index.serviceTabList.content.comment8'),
        image: 'https://res.oafimg.cn/-/592c03f46dfd5cf8/service-21.png',
      },
    ],
  },
  {
    title: t('projects.index.serviceTabList.title3'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title9'),
        comment: t('projects.index.serviceTabList.content.comment9'),
        image: 'https://res.oafimg.cn/-/610e4710a6f59603/service-5.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title10'),
        comment: t('projects.index.serviceTabList.content.comment10'),
        image: 'https://res.oafimg.cn/-/e8cf47f0a63aec58/service-6.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title11'),
        comment: t('projects.index.serviceTabList.content.comment11'),
        image: 'https://res.oafimg.cn/-/d55bb18117a4fdc4/service-15.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title12'),
        comment: t('projects.index.serviceTabList.content.comment12'),
        image: 'https://res.oafimg.cn/-/1202916227537f5d/service-17.png',
      },
    ],
  },
  {
    title: t('projects.index.serviceTabList.title4'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title17'),
        comment: t('projects.index.serviceTabList.content.comment17'),
        image: 'https://res.oafimg.cn/-/e3c81da433acab91/service-12.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title18'),
        comment: t('projects.index.serviceTabList.content.comment18'),
        image: 'https://res.oafimg.cn/-/45227d7be3ee18d0/service-13.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title19'),
        comment: t('projects.index.serviceTabList.content.comment19'),
        image: 'https://res.oafimg.cn/-/488c461ebd6f6ec4/service-14.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title20'),
        comment: t('projects.index.serviceTabList.content.comment21'),
        image: 'https://res.oafimg.cn/-/0fba5d43cb656106/service-7.png',
      },
      {
        id: 5,
        title: t('projects.index.serviceTabList.content.title21'),
        comment: t('projects.index.serviceTabList.content.comment20'),
        image: 'https://res.oafimg.cn/-/39509fefc982546e/service-16.png',
      },

    ],
  },
  {
    title: t('projects.index.serviceTabList.title5'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title22'),
        comment: t('projects.index.serviceTabList.content.comment22'),
        image: 'https://res.oafimg.cn/-/13f7c234ebc5fd78/project-1.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title23'),
        comment: t('projects.index.serviceTabList.content.comment23'),
        image: 'https://res.oafimg.cn/-/a7767123ecd6bab1/project-2.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title24'),
        comment: t('projects.index.serviceTabList.content.comment24'),
        image: 'https://res.oafimg.cn/-/46ecec4f2c925218/project-3.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title25'),
        comment: t('projects.index.serviceTabList.content.comment25'),
        image: 'https://res.oafimg.cn/-/8d6878bb13f4b954/project-4.png',
      },
      {
        id: 5,
        title: t('projects.index.serviceTabList.content.title26'),
        comment: t('projects.index.serviceTabList.content.comment26'),
        image: 'https://res.oafimg.cn/-/e84c69f87dd953db/project-5.png',
      },
      {
        id: 6,
        title: t('projects.index.serviceTabList.content.title27'),
        comment: t('projects.index.serviceTabList.content.comment27'),
        image: 'https://res.oafimg.cn/-/b019a18087deec1c/project-6.png',
      },
    ],
  },
]);

const { data: globalConfig } = useAsyncData('project:config', () => $fetch('/web/openatom/config/v1/getone'));
const { data: archivedList } = useAsyncData('project:archived', () => $fetch('/project/v1/list', { data: { status: 4 } }));
const { data: incubateList } = useAsyncData('project:incubate', () => $fetch('/project/v1/list', { data: { status: 2 } }));
const { data: donateList } = useAsyncData('project:donate', () => $fetch('/project/v1/list', { data: { status: 1 } }));
const { data: graduationList } = useAsyncData('project:graduation', () => $fetch('/project/v1/list', { data: { status: 3 } }));

const tabPanelsRef = useTemplateRef('tabPanelsEl');
const tabPanelRefs = ref<HTMLElement[]>([]);
const isAnimating = ref(false);

// 设置tab面板引用
const setTabPanelRef = (el: Element | ComponentPublicInstance | null) => {
  if (el) {
    const element = el as HTMLElement;
    if (!tabPanelRefs.value.includes(element)) {
      tabPanelRefs.value.push(element);
    }
  }
  else {
    tabPanelRefs.value = [];
  }
};

// 计算所有tab面板中的最大高度
const getMaxPanelHeight = () => {
  if (tabPanelRefs.value.length === 0) {
    return 'auto';
  }

  let maxHeight = 0;
  tabPanelRefs.value.forEach(panel => {
    if (panel) {
      const height = panel.scrollHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    }
  });

  return maxHeight > 0 ? `${maxHeight}px` : 'auto';
};

// 动画开始前设置固定高度
const beforeEnter = () => {
  isAnimating.value = true;
  nextTick(() => {
    if (tabPanelsRef.value) {
      const maxHeight = getMaxPanelHeight();
      tabPanelsRef.value.style.height = maxHeight;
      tabPanelsRef.value.style.minHeight = maxHeight;
    }
  });
};

// 动画结束后恢复自适应高度
const afterLeave = () => {
  isAnimating.value = false;
  nextTick(() => {
    if (tabPanelsRef.value && !isAnimating.value) {
      tabPanelsRef.value.style.height = '';
      tabPanelsRef.value.style.minHeight = '';
    }
  });
};

// 组件挂载后初始化高度
onMounted(() => {
  nextTick(() => {
    if (tabPanelsRef.value) {
      const maxHeight = getMaxPanelHeight();
      tabPanelsRef.value.style.height = maxHeight;
      tabPanelsRef.value.style.minHeight = maxHeight;
    }
  });
});
</script>

<template>
  <main class="page-projects bg-white">
    <div class="h-400 bg-[url(@/home/assets/project/banner.jpg)] bg-cover bg-right bg-no-repeat text-#2d2d2d">
      <div class="container pt-143">
        <h1 class="m-0 text-50 font-medium">{{ $t('projects.index.project1') }}</h1>
        <span class="mt-18 block max-w-900 text-24 leading-30 <2xl:max-w-600" v-if="globalConfig?.configInfo.project">
          {{ globalConfig.configInfo.project.pageDesc[locale] }}
        </span>
      </div>
    </div>

    <!-- 毕业项目 -->

    <a id="graduation"></a>

    <ProjectSection
      :title="$t('projects.index.project5')"
      :description="globalConfig.configInfo.project?.titleDesc4?.[locale]"
      :project-list="graduationList"
      v-if="globalConfig?.configInfo.project"
    >
      <template #card="{ data: listing }">
        <CardPrimary
          v-for="item in listing"
          :key="item.id"
          :item="item"
          :description-list="descriptionList"
        />
      </template>
    </ProjectSection>

    <!-- 孵化项目 -->

    <a id="incubation"></a>

    <ProjectSection
      :title="$t('projects.index.project2')"
      :description="globalConfig.configInfo.project?.titleDesc1?.[locale]"
      :project-list="incubateList"
      v-if="globalConfig?.configInfo.project"
    >
      <template #card="{ data: listing }">
        <CardPrimary
          v-for="item in listing"
          :key="item.id"
          :item="item"
          :description-list="descriptionList"
        />
      </template>
    </ProjectSection>

    <!-- 预备项目 -->

    <a id="preparatory"></a>

    <ProjectSection
      :title="$t('projects.index.project3')"
      :description="globalConfig.configInfo.project?.titleDesc2?.[locale]"
      :project-list="donateList"
      show-more-button
      v-if="globalConfig?.configInfo.project"
    >
      <template #card="{ data: listing }">
        <CardSecondary
          v-for="item in listing"
          :key="item.id"
          :item="item"
          :description-list="descriptionList"
        />
      </template>
    </ProjectSection>

    <!-- 已归档项目 -->

    <a id="archived"></a>

    <ProjectSection
      :title="$t('projects.index.project4')"
      :description="globalConfig.configInfo.project?.titleDesc3?.[locale]"
      :project-list="archivedList"
      show-more-button
      v-if="globalConfig?.configInfo.project"
    >
      <template #card="{ data: listing }">
        <CardSecondary
          v-for="item in listing"
          :key="item.id"
          :item="item"
          :description-list="descriptionList"
        />
      </template>
    </ProjectSection>

    <div class="bg-[rgba(45,45,45,0.02)] pb-96 pt-36">
      <h2 class="mb-48 mt-0 h-48 text-center text-32 text-#2d2d2d font-medium leading-48">
        {{ $t('projects.index.foundationService') }}
      </h2>

      <div class="container">
        <TabGroup v-slot="{ selectedIndex }">
          <TabList class="flex justify-center">
            <Tab v-for="item in serviceTabList" :key="item.title" as="template" v-slot="{ selected }">
              <div
                :class="{
                  'text-#1180ff': selected,
                  'text-#2d2d2d': !selected,
                }"
                class="w-146 flex-center cursor-pointer break-words pb-16 text-24 siblings:ml-88px focus-visible:outline-unset"
              >
                {{ item.title }}
              </div>
            </Tab>
          </TabList>

          <div class="h-1 w-full overflow-hidden bg-[rgba(45,45,45,.06)]">
            <!-- (container宽度 - (tab宽度 * tab数量 + tab间距 * (tab数量 - 1))) / 2 = ml值 -->
            <!-- (1360 - (146 * 5 + 88 * (5 - 1))) / 2 = 139 -->
            <!-- (1200 - (146 * 5 + 88 * (5 - 1))) / 2 = 59 -->
            <div
              class="ml-139 h-full w-fit flex flex-nowrap transition-transform duration-300 <2xl:ml-59px after:w-88px after:content-empty"
              :style="{ transform: `translateX(${selectedIndex * 100}%)` }"
            >
              <div class="w-146px bg-brand-primary"></div>
            </div>
          </div>

          <TabPanels as="template">
            <div class="relative mt-32" ref="tabPanelsEl">
              <TabPanel v-for="item in serviceTabList" :key="item.title" as="template" static v-slot="{ selected }">
                <Transition name="tab-panel" @before-enter="beforeEnter" @after-leave="afterLeave">
                  <ul class="m-0 flex flex-wrap list-none justify-start gap-32 p-0 <2xl:gap-24" v-show="selected" :ref="setTabPanelRef">
                    <li
                      class="group relative h-286px w-316px flex-shrink-0 overflow-hidden rounded-4px bg-[#fff] shadow-[rgba(0,0,0,0.08)_0_0_8px_0] <2xl:h-256 <2xl:w-282"
                      v-for="piece in item.content"
                      :key="piece.id"
                    >
                      <img :data-src="piece.image" class="lazyload block h-214px w-100% object-cover <2xl:h-184px" :alt="piece.title">

                      <div class="absolute z-1 h-146 w-full bg-white transition-transform duration-300 group-hover:translate-y--74px group-hover:py-24">
                        <div class="overflow-y-auto group-hover:h-[calc(100%-48px)]">
                          <h4 class="m-0 h-74 flex-center px-32 text-16 text-#2d2d2d font-medium leading-24 group-hover:h-auto">
                            {{ piece.title }}
                          </h4>

                          <p class="mb-0 mt-8 px-32 text-center text-14 text-#9a9ea6 leading-22">{{ piece.comment }}</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </Transition>
              </TabPanel>
            </div>
          </TabPanels>
        </TabGroup>
      </div>
    </div>
  </main>
</template>

<style lang="scss" scoped>
.page-projects {
  .tab-panel-enter-active,
  .tab-panel-leave-active {
    transition: transform .9s, opacity .9s;
    will-change: transform, opacity;
  }

  .tab-panel-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .tab-panel-enter-from,
  .tab-panel-leave-to {
    transform: translateY(12px);
    opacity: 0;
  }
}
</style>
